import { useRef } from 'react';
import { observer } from 'mobx-react-lite';

import PageLayout from '../../../shared/components/PageLayout';
import StripeElementsProvider from '../../../shared/components/StripeElementsProvider';
import { getCurrencyForAreaUnit } from '../../../shared/helpers/functions/currency';
import rootStore from '../../features/rootStore/RootStore';
import useIframeResize from '../../../shared/hooks/useIframeResize';

const PlanSelectPageLayout = observer(() => {
  const { areaUnitStore } = rootStore;
  const { areaUnit } = areaUnitStore;
  const currency = getCurrencyForAreaUnit(areaUnit);
  const pageRef = useRef(null);

  useIframeResize(pageRef);

  return (
    <StripeElementsProvider currency={currency}>
      <PageLayout ref={pageRef} />
    </StripeElementsProvider>
  );
});

export default PlanSelectPageLayout;
